import { buildCsv } from './downloadOriginCsv';
import {
  customerLeadColumns,
  customerMetricColumns,
} from './downloadReportCatalog';

export { buildCsv };

export const customerCsvFileName = (subtype, from, to) => {
  const safePart = value => String(value || '').replace(/:/g, '-');
  const kind = subtype === 'product_sales_to_customer' ? 'product' : 'top';
  return `customer-${kind}-${safePart(from)}-to-${safePart(to)}.csv`;
};

export const customerCsvLeadCells = (row, subtype) =>
  customerLeadColumns(subtype).map(column => (row || {})[column] || '');

export const customerCsvMetricCells = (metrics, subtype) =>
  customerMetricColumns(subtype).map(column => (metrics || {})[column] ?? 0);
